import React from 'react';
import { getResizedImageUrl } from '@lib/image';
import styles from './styles.module.scss';

interface SlideData {
  id: number;
  image: string;
  title: string;
  url: string;
}

interface ISlideProps {
    slide: SlideData;
}

const Slide = ({
  slide: {
    image, title, url
  }
}: ISlideProps) => {
  const resizedImageUrl = getResizedImageUrl({
    format: 'jpeg',
    url: image,
    width: 420,
  });

  return (
    <a
      className={ styles.Root }
      href={ url }
    >
      <img
        alt={ title }
        className={ styles.Image }
        src={ resizedImageUrl }
      />

      <div className={ styles.Title }>
        { title }
      </div>
    </a>
  );
};

export default Slide;
